import React from 'react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  return <section className="py-5 px-6 bg-midnight-light border-t border-gold/10" data-id="element-125">
      <div className="max-w-5xl mx-auto" data-id="element-126">
        <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-8" data-id="element-127">
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 1.5
        }} className="w-full lg:w-2/5 flex justify-center" data-id="element-128">
            <img src="https://cdn.magicpatterns.com/uploads/qix5QrNzpRmt5i52T5a9q7/PORTADA_EBOOK_RUPTURA.png" alt="Código Post-Ruptura" className="w-full max-w-xs opacity-90 pt-[20px] pb-[20px]" data-id="element-129" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="w-full lg:w-3/5 text-center lg:text-left" data-id="element-130">
            <h2 className="font-cinzel text-3xl md:text-4xl text-white leading-tight mb-3 tracking-[0.1em]" data-id="element-131">
              NO ES AMOR.
              <br data-id="element-132" />
              ES UNA <span className="text-gold" data-id="element-133">ADICCIÓN QUÍMICA.</span>
            </h2>
            <p className="font-sans text-sm text-gray-400 font-light leading-loose mb-3" data-id="element-134">
              ¿Sabés esa sensación? El vacío en el pecho al despertar, la mano
              que va sola al perfil de él, la humillación de escribir y quedarte
              mirando el visto. Esa no sos vos, es tu ansiedad. Esta es tu hoja
              de ruta para sobrevivir al incendio sin quemar tu orgullo.
            </p>
            <p className="font-cinzel text-gold tracking-widest text-sm border-t border-gold/20 pt-3" data-id="element-135">
              Necesitás un sistema. Este es el sistema.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}